import { useState } from "react";
import { ChevronDown } from "lucide-react";

// Lightweight collapsible section used throughout the dashboard. State is
// intentionally in-memory only — every page reload (including post-upload)
// starts every section collapsed. Avoids the "ghost open section" confusion
// that came with localStorage persistence.
export function CollapsibleBlock({
  title,
  storageKey: _storageKey,
  defaultOpen = false,
  children,
  testid,
  wrapClassName = "",
  onHeaderTap,
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div data-testid={testid} className={`space-y-3 sm:space-y-4 ${wrapClassName}`}>
      <button
        type="button"
        onClick={() => {
          setOpen((v) => !v);
          if (onHeaderTap) onHeaderTap();
        }}
        data-testid={`${testid}-toggle`}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 px-3 sm:px-4 py-2.5 rounded-lg border border-[#E6EBE8] bg-white hover:bg-[#F7F9F8] active:bg-[#F0F4F2] transition-colors text-left"
      >
        <span className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em] text-[#1B3B2E] truncate">
          {title}
        </span>
        <ChevronDown
          className={`h-5 w-5 text-[#5C746A] shrink-0 transition-transform duration-200 ${open ? "rotate-0" : "-rotate-90"}`}
          strokeWidth={2}
        />
      </button>
      {open ? <div data-testid={`${testid}-body`}>{children}</div> : null}
    </div>
  );
}
